// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--2pfLL","content":"styles-module--content--2BDai","bezel":"styles-module--bezel--mzVag","image":"styles-module--image--3Ysnr"};